import { MarriageSelfAssessed } from "@/models"
import { formatPropertyName } from "@/utils/formatPropertyName"
import { defineComponent, type ReactiveComponent } from "vue-utils"
import { useEditingMarriageClaimState } from "../state"
import { getBooleanDisplayValue, getIcon } from "./utils"

const SelfAssessed: ReactiveComponent = () => {
	const state = useEditingMarriageClaimState()

	return () => (
		<div>
			<div class="d-flex gap-1">
				<h6>Is Self Assessed?:</h6>
				<h6 class="fw-bold">{getBooleanDisplayValue(state.fullClaim.IsSelfAssessed, "Unsure")}</h6>
			</div>
			{state.fullClaim.IsSelfAssessed !== false && (
				<table
					class={`table small table-striped table-hover grid-table grid-table-bordered`}
					style={{
						gridTemplateColumns: `4rem 1fr`,
						marginTop: `1rem`,
					}}
				>
					<tbody>
						{Object.keys(state.fullClaim.SelfAssessed).map((check) => (
							<tr key={check}>
								<td class="d-flex align-items-center justify-content-center p-1" style="font-size: 1.75rem">
									{getIcon(state.fullClaim.SelfAssessed[check as keyof MarriageSelfAssessed])}
								</td>
								<td class="d-flex align-items-center">{`${formatPropertyName([check])}?`}</td>
							</tr>
						))}
					</tbody>
				</table>
			)}
		</div>
	)
}

export default defineComponent(SelfAssessed)
